import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

export default new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [
    {
      path: '/',
      name: 'Home',
      meta: {
        title: 'Home'
      },
      // the welcome page for visitors, the dashboard once signed in
      component: () => import('../views/Start')
    },
    {
      path: '/login',
      name: 'Login',
      meta: {
        title: 'Sign in'
      },
      component: () => import('../views/Dashboard')
    },
    {
      path: '/admin',
      name: 'Admin',
      meta: {
        title: 'Admin'
      },
      component: () => import('../views/Admin')
    },
    {
      path: '/statistics',
      name: 'Statistics',
      meta: {
        title: 'Statistics'
      },
      component: () => import('../views/Statistics')
    },
    {
      // sales simulator (administrators): a new simulation, or a saved one by id
      path: '/simulator/:id?',
      name: 'Simulator',
      meta: {
        title: 'Simulator'
      },
      component: () => import('../views/Simulator')
    },
    {
      path: '/simulations',
      name: 'Simulations',
      meta: {
        title: 'Simulations'
      },
      component: () => import('../views/Simulations')
    },
    {
      // partner companies, their users and invitations (administrators)
      path: '/companies',
      name: 'Companies',
      meta: {
        title: 'Companies'
      },
      component: () => import('../views/Companies')
    },
    {
      path: '/companies/:id',
      name: 'Company',
      meta: {
        title: 'Company'
      },
      component: () => import('../views/CompanyDetail')
    },
    {
      path: '/profile',
      name: 'Profile',
      meta: {
        title: 'Profile'
      },
      component: () => import('../views/Profile')
    },
    {
      path: '/retire-tokens',
      name: 'Retire Tokens',
      meta: {
        title: 'Retire tokens'
      },
      component: () => import('../views/LockTokens')
    },
    {
      path: '/notifications',
      name: 'Notifications',
      meta: {
        title: 'Notifications'
      },
      component: () => import('../views/Notifications')
    },
    {
      path: '/notifications/unsubscribe/:token',
      name: 'Unsubscribe',
      meta: {
        title: 'Unsubscribe'
      },
      component: () => import('../views/Unsubscribe')
    },
    {
      path: '/marketplace',
      name: 'Marketplace',
      meta: {
        title: 'Marketplace'
      },
      component: () => import('../views/Marketplace')
    },
    {
      path: '/my-orders',
      name: 'My Orders',
      meta: {
        title: 'My Orders'
      },
      component: () => import('../views/MyOrders')
    },
    {
      path: '/areas/:id',
      name: 'Area Item',
      meta: {
        title: 'Area Item'
      },
      component: () => import('../views/Areas/AreaItem'),
    },
    {
      path: '/areas',
      redirect: '/areas-map'
    },
    {
      path: '/areas-list',
      name: 'Areas list',
      meta: {
        title: 'Areas list'
      },
      component: () => import('../views/Areas/AreasList'),
    },
    {
      path: '/areas-map',
      name: 'Areas map',
      meta: {
        title: 'Areas map'
      },
      component: () => import('../views/Areas/AreasMap'),
    },
    {
      path: '/tree-types/:id',
      name: 'Tree types form',
      meta: {
        title: 'Tree type form'
      },
      component: () => import('../views/TreeTypes/TreeTypeItem'),
    },
    {
      path: '/tree-types',
      name: 'Tree types',
      meta: {
        title: 'Tree types'
      },
      component: () => import('../views/TreeTypes'),
    },
    {
      path: '/customers',
      name: 'Customers',
      meta: {
        title: 'Customers'
      },
      component: () => import('../views/Customers'),
    },
    {
      path: '/customers/:id',
      name: 'Customers',
      meta: {
        title: 'Customer form'
      },
      component: () => import('../components/Customer/CustomerFormComponent'),
    },
    {
      path: '/Dashboard',
      name: 'Dashboard',
      meta: {
        title: 'Dashboard'
      },
      component: () => import('../views/Dashboard')
    },
    {
      path: '*',
      meta: {
        title: 'Error 404',
        error: 404
      },
      component: () => import('../views/Error')
    }
  ]
})
